import React, { useState } from 'react'
import moment from 'moment'
import injectStyles from 'react-jss'
import { Col, Grid, Row } from 'react-bootstrap'
import {
  CONTRACT_TYPE_TO_NAME_MAP,
  GERMANY_CONTRACT_STATUSES,
} from '../../../../../../../../shared/constants'
import StatusLabel from '../StatusLabel'
import { styles } from './styles'
import AddendumList from '../AddendumList'
import ArrowBottomIcon from '../../../../../../../../Assets/Images/icons/arrowBottom'

const ContractItem = ({
  classes,
  onContractNameClick,
  ambassador,
  contract: contractGroup,
  generateContractName,
  onCancelAddendum,
  generateAddendumName,
}) => {
  const { contract, addendums } = contractGroup
  const [openAddendum, setOpenAddendum] = useState(
    contract.status === GERMANY_CONTRACT_STATUSES.STATUS_ACTIVE,
  )

  return (
    <Grid fluid>
      <Row>
        <Col xs={3}>
          <p className={classes.columnHeader} style={{ marginLeft: 20 }}>
            Contract
          </p>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div
              style={{
                transform: openAddendum ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
              className={classes.arrowButton}
              onClick={() => setOpenAddendum(!openAddendum)}
            >
              <ArrowBottomIcon />
            </div>
            <div
              className={classes.link}
              onClick={() => onContractNameClick(contract)}
            >
              {generateContractName(contract)}
            </div>
          </div>
        </Col>
        <Col xs={2}>
          <p className={classes.columnHeader}>Status</p>
          <StatusLabel data={contract} startDate={contract.startAt} />
        </Col>
        <Col xs={2}>
          <p className={classes.columnHeader}>Contract type</p>
          <p className={classes.columnValue}>
            {CONTRACT_TYPE_TO_NAME_MAP[contract.templateDocument.name]}
          </p>
        </Col>
        <Col xs={1}>
          <p className={classes.columnHeader}>Hours</p>
          <p className={classes.columnValue}>
            {contract.metadata ? contract.metadata.fields.hoursPerWeek : '-'}
          </p>
        </Col>
        {!contract.signedAt ? (
          <Col xs={2}>
            <p className={classes.columnHeader}>Sent on</p>
            <p className={classes.columnValue}>
              {contract.createdAt && ambassador.city.timezone
                ? moment(new Date(Number(contract.createdAt)))
                    .tz(ambassador.city.timezone)
                    .format('DD.MM.YYYY HH:mm')
                : '-'}
            </p>
          </Col>
        ) : null}

        {contract.signedAt ? (
          <Col xs={1}>
            <p className={classes.columnHeader}>Start date</p>
            <p className={classes.columnValue}>
              {contract.startAt
                ? moment(contract.startAt).format('DD.MM.YYYY')
                : '-'}
            </p>
          </Col>
        ) : null}
        {contract.signedAt ? (
          <Col xs={1}>
            <p className={classes.columnHeader}>End date</p>
            <p className={classes.columnValue}>
              {contract.endAt
                ? moment(contract.endAt).format('DD.MM.YYYY')
                : '-'}
            </p>
          </Col>
        ) : null}

        <Col xs={2}>
          <p className={classes.columnHeader}>Sent by</p>
          <p
            className={classes.userLink}
            onClick={() => {
              window.open(
                `/dashboard/users/${
                  contract.metadata ? contract.metadata.sender.id : null
                }`,
                '_blank',
              )
            }}
          >
            {contract.metadata ? contract.metadata.sender.name : '-'}
          </p>
        </Col>
      </Row>
      {openAddendum && addendums && addendums.length > 0 && (
        <AddendumList
          isOpen={openAddendum}
          addendums={addendums}
          onContractNameClick={onContractNameClick}
          onCancelAddendum={onCancelAddendum}
          generateAddendumName={generateAddendumName}
          contract={contract}
          ambassador={ambassador}
        />
      )}
    </Grid>
  )
}

export default injectStyles(styles)(ContractItem)
